import { isPlainObject } from 'lodash';
import { Media, MediaKey, UnitValue } from '../types';

export function getMediaProp(prop?: string | Media<string>, values?: { [key: string]: UnitValue }) {
  if (!prop || !values) {
    return undefined;
  }

  if (!isPlainObject(prop)) {
    return values[prop as string];
  }

  const mediaKeys = Object.keys(prop) as MediaKey[];
  const result: Media<UnitValue> = {};

  mediaKeys.forEach(item => {
    const propValue = (prop as Media<string>)[item];
    if (propValue) {
      result[item] = values[propValue];
    }
  });

  return result;
}
